var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row left-align vert-offset-top-1"},[_c('div',{staticClass:"col s12 l10 offset-l1"},[(_vm.isLoyalToLocal)?_c('home-loyal-to-local-component'):_vm._e(),(_vm.isFoodCredit)?_c('home-food-credit-component'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }